import styled from 'styled-components';

import { Delete, ExpandLess } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';

export const ChatBackground = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  flex: 1;
  max-height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
`;

export const InfitineScrollContainer = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: column-reverse;
  height: 100%;
`;

export const ChatPlaceholder = styled.div`
  text-align: center;

  svg {
    width: ${wellzTheme.spacing(25)};
    height: ${wellzTheme.spacing(25)};
  }
`;

export const PlaceholderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ScheduledMessageWrapper = styled(Accordion)`
  display: flex;
  flex-direction: column;

  padding: ${wellzTheme.spacing(2)};
  margin-left: auto;
  margin-right: ${wellzTheme.spacing(3)};
  margin-bottom: ${wellzTheme.spacing(3)};

  background-color: ${wellzTheme.palette.secondary.main};

  &:first-of-type {
    border-radius: ${wellzTheme.spacing(2)};
    border-bottom-right-radius: ${wellzTheme.spacing(0.5)};
  }

  width: 60%;
  max-width: 60%;

  box-shadow: none;
`;

export const ScheduledMessageHeaderIcon = styled(ExpandLess)`
  fill: ${wellzTheme.palette.primary.main};
`;

export const ScheduledMessageHeader = styled(AccordionSummary)`
  width: 100%;
  padding: 0;

  .MuiAccordionSummary-content {
    display: flex;
    flex-direction: column;
    gap: ${wellzTheme.spacing(0.5)};
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const ScheduledMessageContainer = styled(AccordionDetails)`
  margin-top: ${wellzTheme.spacing(2)};
  padding: ${wellzTheme.spacing(2)};
  border-radius: ${wellzTheme.spacing(1)};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: white;
`;

export const ScheduledMessage = styled(Box)`
  margin-bottom: ${wellzTheme.spacing(2)};

  width: 100%;

  text-align: left;

  p {
    color: ${wellzTheme.palette.text.secondary};
  }
`;

export const TrashIcon = styled(Delete)`
  fill: ${wellzTheme.palette.primary.main};
`;
